import { Avatar, AvatarGroup, Box, InputLabel, Stack, Tooltip, Typography, useTheme } from '@mui/material'
import { CommentData, User } from 'types'
import { formatDateTime } from 'utils/formatDayjsDateTime'

const ReadByIcon = ({ note, users }: { note: CommentData; users: User[] }) => {
  const _theme = useTheme()
  // Filter readBy entries to ones whose user actually loaded — protects
  // against users[] being empty/stale during initial load and against
  // readBy referencing deleted users. Previously this crashed because
  // users?.find() returns undefined when the lookup misses and the
  // render then tried to read readByUser.user_uuid.
  const readByWithUser = (note.readBy ?? [])
    .map((read: any) => ({
      read,
      user: users?.find(u => u?.user_uuid === read?.user_uuid) ?? null,
    }))
    .filter(entry => entry.user !== null) as Array<{ read: any; user: User }>

  return (
    <Tooltip
      title={
        <Stack>
          <InputLabel sx={{ fontSize: 11, textAlign: 'left' }}>Viewed by:</InputLabel>
          {readByWithUser.map(({ read, user }) => (
            <Box key={`${note?.SK}-${user.user_uuid}`} className="box-row">
              <Avatar alt={user.user_uuid} src={user.image_512} sx={{ width: 24, height: 24, ml: 0.5 }} />
              <Typography sx={{ color: 'text.secondary', fontSize: 12 }}>{formatDateTime(read.readAt)}</Typography>
            </Box>
          ))}
        </Stack>
      }
    >
      <div>
        <AvatarGroup max={4}>
          {readByWithUser.map(({ user }) => (
            <Avatar
              key={`${note?.SK}-${user.user_uuid}`}
              alt={user.user_uuid}
              src={user.image_512}
              sx={{ width: 16, height: 16, ml: 0.5 }}
            />
          ))}
        </AvatarGroup>
      </div>
    </Tooltip>
  )
}
export default ReadByIcon
